<div class="view-all-button" [style.background]="backgroundColor">
    <div class="button-text" [style.color]="textColor">
        {{ label }}
    </div>
    <div class="icon-container">
        <img src="assets/icons/arrow-right.svg" alt="arrow-right">
    </div>
</div>